import React from 'react';
import { Box, Text, Image, Center } from '@chakra-ui/react';

import WithAnimation from '@components/Common/WithAnimation';
import CountDown from '@components/Common/CountDown/V3';
import RSVP from '@components/Section/RSVP';
import LocationAndCalendar from '@/components/Section/Wedding/Location';

import useGuestName from '@/hooks/useGuestName';
import useSPH from '@hooks/useSPH';

import { BG_RSVP } from '@/constants/assets';
import { ID_COUPLE_SECTION, ID_RSVP_SECTION } from '@/constants/identifier';

function CoupleInfo({ ...rest }) {
  const guestName = useGuestName();
  const sph = useSPH();

  return (
    <Box bgColor="bgPrimary" name={ID_COUPLE_SECTION} {...rest}>
      <Box padding="16px">
        <WithAnimation>
          <Text align="center" color="mainColorDarkText">
            Dear Mr./Mrs.,
          </Text>
        </WithAnimation>
        {guestName && (
          <WithAnimation>
            <Text align="center" fontSize="lg" color="mainColorDarkText" marginBottom="12px">
              {guestName}
            </Text>
          </WithAnimation>
        )}
        <WithAnimation>
          <Text align="center" fontSize="md" padding="0 16px 0 16px" color="mainColorDarkText">
            With this, we would like to invite you to our New Family Orientation.
          </Text>
        </WithAnimation>

        <Box margin="0 auto">
          <CountDown lang="en" />
        </Box>
        <WithAnimation>
          <Image
            borderRadius="16px"
            src={sph.imgRundown}
            width="90%"
            margin="0 auto"
            marginTop="16px"
          />
        </WithAnimation>
        <Center marginTop="16px">
          <WithAnimation>
            <LocationAndCalendar />
          </WithAnimation>
        </Center>
      </Box>

      <Box padding="32px 16px" name={ID_RSVP_SECTION}>
        <Box
          bgColor="bgAlternative"
          borderRadius="16px"
          bgImage={`url(${BG_RSVP})`}
          bgSize="cover"
          bgPos="top"
        >
          <Box padding="52px 24px 24px 24px" borderRadius="16px">
            <RSVP lang="en" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(CoupleInfo);
